"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CaretDown = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DEFAULT_SIZE = 24;
const CaretDown = _ref => {
  let {
    size = DEFAULT_SIZE,
    color = "#212121",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    size: size,
    color: color
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M6.102 8c-1.074 0-1.648 1.265-.94 2.073l5.52 6.31a1.75 1.75 0 0 0 2.635 0l5.522-6.31c.707-.808.133-2.073-.941-2.073H6.102Z"
  }));
};
exports.CaretDown = CaretDown;
CaretDown.displayName = "CaretDown";